import {
  ProfileCard as ProfileCardComponent,
  ProfileCardProps as ProfileCardComponentProps,
} from "@kunduz/feature-landing-pages";
import { ComponentConfig } from "@measured/puck";
import { defaultComponentSize, defaultComponentSizeFields } from "../../utils";

export interface ProfileCardProps extends ProfileCardComponentProps {}

const ProfileCard = (props: ProfileCardProps) => {
  return <ProfileCardComponent {...props} />;
};

export const PuckProfileCard: ComponentConfig<ProfileCardProps> = {
  label: "Profile Card",
  fields: {
    image: { type: "text", label: "Image URL" },
    title: { type: "text", label: "Title" },
    name: { type: "text", label: "Name" },
    options: {
      type: "object",
      label: "Options",
      objectFields: {
        ...(defaultComponentSizeFields as any),
      },
    },
  },
  defaultProps: {
    image: "",
    title: "",
    name: "",
    options: {
      ...defaultComponentSize,
    },
  },
  render: (props) => <ProfileCard {...props} />,
};
